import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class SessionManagementService {
  constructor() {}

  public saveItemOnSession(key: string, value: string) {
    if (key && value) {
      sessionStorage.setItem(key, value)
    }
  }

  public getItemFromSession(key: string) {
    if (key) {
      return sessionStorage.getItem(key)
    }
    return null
  }

  public removeItemFromSession(key: string) {
    sessionStorage.removeItem(key)
  }
}
